// ConfirmDialog.js
import React from "react";

export default function ConfirmDialog({ open, message, onConfirm, onCancel }) {
  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(0,0,0,0.3)',
      zIndex: 9999
    }}>
      <div style={{
        background: '#fff',
        padding: 24,
        borderRadius: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        minWidth: 300
      }}>
        <div className="modal-body">
          <p>{message}</p>
          <div className="modal-footer">
            <button type="button" onClick={onConfirm} data-bs-dismiss="modal" className="btn btn-danger">Löschen</button>
            &nbsp;&nbsp;
            <button type="button" onClick={onCancel} data-bs-dismiss="modal" className="btn btn-primary" aria-label="Close">Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
  );
}